import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ApiService } from '@services/api.service';
import { ManagementCombinedSubcostModel } from '@data-layer/models/management';
import { PaginatedResultModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class SubcostManagementRepository {
  constructor(private apiService: ApiService) {}

  public getPriceListSubcosts(
    pricelistId: number,
    isShowLoader?: boolean,
  ): Observable<PaginatedResultModel<ManagementCombinedSubcostModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementCombinedSubcostModel>>(
      `${environment.url.freight.combinedSubcost}`,
      { params: { pricelistId } },
      { isShowLoader },
    );
  }

  public updateCombinedSubcost(data: ManagementCombinedSubcostModel, isShowLoader?: boolean): Observable<ManagementCombinedSubcostModel> {
    return this.apiService.put<ManagementCombinedSubcostModel>(`${environment.url.freight.combinedSubcost}/${data.id}`, data, null, {
      isShowLoader,
    });
  }

  public deleteCombinedSubcost(id: number, isShowLoader?: boolean): Observable<ManagementCombinedSubcostModel> {
    return this.apiService.delete<ManagementCombinedSubcostModel>(`${environment.url.freight.combinedSubcost}/${id}`, null, {
      isShowLoader,
    });
  }
}
